import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-search-input',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule
    ],
    templateUrl: './search-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './search-input.component.scss'
})
export class SearchInputComponent {
    @Input() label: string = 'Search';
    @Output() searchEvent = new EventEmitter<string>();
    @Input() value: string | number = '';

    onSearch(event: any) {
        this.searchEvent.emit(event.target.value);
    }
}
